export default __webpack_public_path__ + "media/shared/high-five@3x-f360a7b0.png";